import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Container, Row } from 'reactstrap';
import RightSideContent from './RightSideContent';
import Section from './Section';

const MyProfile = () => {
    return (
        <React.Fragment>
            <Helmet>
                <title>My Profile | Jobseekers Page </title>
            </Helmet>
            <Section />
            <section className="section">
                <Container>
                    <Row style={{justifyContent: 'center'}}>
                        <RightSideContent />
                    </Row>
                </Container>
            </section>
        </React.Fragment>
    )
}

export default MyProfile
